import React from "react";
import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { FormattedMessage } from "react-intl";

import GetImages from "@/components/GetImages";

const NotificationsEmptyState: React.FC = () => {
  return (
    <Grid
      item
      xs={12}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      mx={10}
      height={{ xs: "calc(100vh - 7rem)", md: "75vh" }}
    >
      <GetImages
        name="NotificationEmptyStateIcon"
        width="243.33"
        height="212.029"
      />
      <Stack mt={2.7}>
        <Typography
          component={"h3"}
          sx={{
            color: "var(--gray-800)",
            fontSize: "1.6rem",
            fontWeight: "500",
          }}
        >
          <FormattedMessage
            id="opps_no_notifications_yet"
            defaultMessage="Opps ! No Notifications yet"
          />
        </Typography>
        <Typography
          component={"p"}
          sx={{
            color: "var(--gray-700)",
            fontSize: "1.2rem",
            fontWeight: "400",
            marginTop: "0.4rem",
          }}
          textAlign={"center"}
        >
          <FormattedMessage
            id="watch_this_space_for_some_coming_your_way_very_soon"
            defaultMessage="Watch this space for some coming your way very soon"
          />
        </Typography>
      </Stack>
    </Grid>
  );
};

export default NotificationsEmptyState;
